import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import { media, colors, mixins } from '../../../../css';
import { LodgeStatus as lodgeStatus } from '../../../../Marker/Marker.constants';
import Text from '../../../../BuildingBlocks/Text';
import { HEADING_COLORS } from '../../../../BuildingBlocks/Text/Base/Base';
import Button from '../../../../BuildingBlocks/Button';

const { SOLD_OUT } = lodgeStatus;
const { colorBlue03, colorRed, colorGrey04, colorWhite, colorGrey05 } = colors;

export const activeColor = colorGrey05;

const Header = styled.div`
  padding-bottom: 0.5rem;
  border-bottom: 1px solid ${colorGrey04};
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const HeaderLabel = styled(Text.HeadingFifth)`
  font-size: ${mixins.pxToRem(12)};
  line-height: ${mixins.pxToRem(16)};
`;

const PriceLabel = styled(Text.CopyMini)`
  font-size: ${mixins.pxToRem(12)};
  line-height: ${mixins.pxToRem(16)};
`;

const LodgeInfo = styled.div`
  padding-top: 0.5rem;
`;

const LodgeStatus = styled(Text.HeadingFifth)`
  font-size: ${mixins.pxToRem(12)};
  line-height: ${mixins.pxToRem(16)};
  color: ${({ status }) => (status === SOLD_OUT ? colorRed : colorBlue03)};
  width: 100%;
  display: inline-block;
`;

const StrikeoutPrice = styled(Text.CopyMini)`
  color: ${colorRed};
  text-decoration: line-through;
  margin-left: 5px;
  font-weight: 500;
`;

export const SingleListItemContainer = styled.div`
  position: relative;
  display: inline-flex;
  margin-bottom: 10px;
  border: 1px solid ${colorGrey04};
  padding: 8px;
  width: 100%;
  align-items: flex-start;
  flex-direction: row;
  vertical-align: top;
  background-color: ${colorWhite};
  &.active {
    background-color: ${activeColor};
    border: 1px solid ${colors.colorBlue03};
  }
  &.sold-out-disabled {
    background-color: ${colorGrey05};
    * {
      opacity: 0.8;
    }
  }
  border-radius: 2px;
  cursor: pointer;

  ${media.lessThan('md')`width: 100%;`};

  &:hover {
    border: 1px solid ${colors.colorBlue};
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 40%;
  height: auto;
  padding: calc(100% / 10);
  overflow: hidden;
  border-radius: 2px;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    position: absolute;
    top: 0;
    left: 0;

    &:first-child {
      min-height: 100%;
    }
  }

  .placeholder {
    width: 100%;
    height: auto;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.colorGrey04};

    figure {
      width: 40%;
      height: 100%;
    }
  }
`;

export const StyledPropertyImage = styled.img`
  display: block;
  position: absolute;
  top: 0;
  height: 100%;
  width: auto;
`;
export const InstantPropertyFlag = styled.div`
  position: absolute;
  background-color: ${colorBlue03};
  top: 0;
  left: 0;
  width: 100%;
  height: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PropertyInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 11px;
  margin-left: 9px;
  width: 100%;
`;

export const LikeFlagButton = styled.span`
  color: ${colorWhite};
  right: 5px;
  bottom: 8px;
  padding: 7px;
  border-radius: 50%;
  cursor: pointer;
  outline: none;

  figure {
    margin: 0;
    display: block;
  }
`;

export const BookNowButton = styled(Button)`
  position: absolute;
  padding: 7px;
  cursor: pointer;
  outline: none;

  figure {
    margin: 0;
    display: block;
  }
`;

export const BookmarkButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2;
  align-items: flex-end;
  justify-content: flex-end;
`;

const spreadSpinner = ({ spinnerColor, ...rest }) => <CircularProgress {...rest} />;
const StyledSpinner = styled(spreadSpinner)`
  && {
    margin: 0px;
    color: ${props => HEADING_COLORS[props.spinnerColor] || colors.colorBlue};
  }
`;

const Loading = styled(Text.CopyMini)`
  margin: ${mixins.pxToRem(7)} 0 ${mixins.pxToRem(2)} 0;
`;

export default {
  Header,
  HeaderLabel,
  LodgeInfo,
  LodgeStatus,
  StrikeoutPrice,
  StyledSpinner,
  Loading,
  PriceLabel
};
